var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowserError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 98.31",
    style: {
      enableBackground: "new 0 0 122.88 98.31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.32,0h106.24c4.58,0,8.32,3.74,8.32,8.32v81.68c0,4.57-3.74,8.32-8.32,8.32H8.32C3.74,98.31,0,94.57,0,89.99 V8.32C0,3.74,3.74,0,8.32,0L8.32,0z M63.1,40.11L86.2,76.38c0.7,1.09,1.3,3.33,0,3.33H36.68c-1.3,0-0.7-2.24,0-3.33l23.09-36.27 C60.47,39.02,62.41,39.02,63.1,40.11L63.1,40.11z M59.42,70.09h4.02v3.56h-4.02V70.09L59.42,70.09z M63.44,67.63h-4.02 c-0.4-4.88-1.24-7.98-1.24-12.86c0-1.8,1.46-3.26,3.26-3.26c1.8,0,3.26,1.46,3.26,3.26C64.7,59.64,63.85,62.75,63.44,67.63 L63.44,67.63L63.44,67.63z M117.97,23.29H5.29v67.51c0,0.64,0.25,1.2,0.67,1.63c0.42,0.43,0.99,0.67,1.63,0.67h108.04 c0.64,0,1.2-0.25,1.63-0.67c0.43-0.43,0.67-0.99,0.67-1.63V23.29H117.97L117.97,23.29z M106.64,9.35c2.27,0,4.11,1.84,4.11,4.11 c0,2.27-1.84,4.11-4.11,4.11c-2.27,0-4.11-1.84-4.11-4.11C102.54,11.19,104.38,9.35,106.64,9.35L106.64,9.35z M78.8,9.35 c2.27,0,4.11,1.84,4.11,4.11c0,2.27-1.84,4.11-4.11,4.11c-2.27,0-4.11-1.84-4.11-4.11C74.69,11.19,76.53,9.35,78.8,9.35L78.8,9.35z M92.72,9.35c2.27,0,4.11,1.84,4.11,4.11c0,2.27-1.84,4.11-4.11,4.11c-2.27,0-4.11-1.84-4.11-4.11 C88.61,11.19,90.45,9.35,92.72,9.35L92.72,9.35z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserError);
export default __webpack_public_path__ + "static/media/browserError.e6dac060.svg";
export { ForwardRef as ReactComponent };